import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Inventary } from '../models/inventary.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class InventaryService{
   public url: string;
   public user_id: number;

   constructor(
     public _http: Http,
     public variableService:VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.variableService.getCookie('user_id'));
   }

   getInventaries()
   {
     return this._http.get(this.url+'inventaries/'+this.user_id).map(res => res.json());
   }

   getInventary()
   {
     return "getInventary from service";
   }

   addInventary(inventary: Inventary)
   {
     let json = JSON.stringify(inventary);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-inventary/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateInventary(id:number,pInventary: Inventary)
   {
     let json = JSON.stringify(pInventary);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-inventary/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteInventary(id:number)
   {
     return this._http.get(this.url+'delete-inventary/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/inventary.service.ts